/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import CircularProgressComponent from "../../ReportOverview/CircularProgressComponent/CircularProgressComponent";
import "./Performance.css";
import Locale from "../../../locales";

const Performance = ({ summaryStudent }) => {
  const students = useSelector((state) => state.teacherReducer.students);
  const studentPerformance = useSelector(
    (state) => state.teacherReducer.studentPerformance,
  );
  const [studentRating, setStudentRating] = useState(0);

  useEffect(() => {
    const currentstudentRating = students.filter(
      (el) => el.studentId === summaryStudent,
    );
    setStudentRating(currentstudentRating[0].rating);
  }, [students, summaryStudent]);

  return (
    <div className="performance-summary-container">
      <div className="summary-charts-container">
        <div>
          <CircularProgressComponent
            size={60}
            thickness={6}
            variant="determinate"
            value={studentPerformance.punctuality ?? 0}
          />
          <p>{Locale.t("punctuality")}</p>
        </div>
        <div>
          <CircularProgressComponent
            size={90}
            thickness={7}
            variant="determinate"
            value={studentPerformance.consistency ?? 0}
          />
          <p>{Locale.t("consistency")}</p>
        </div>
        <div>
          <CircularProgressComponent
            size={60}
            thickness={6}
            variant="determinate"
            value={studentRating}
          />
          <p>{Locale.t("general_performance")}</p>
        </div>
      </div>
    </div>
  );
};

export default Performance;
